<fieldset class="m-0 border-0 p-0" [formGroup]="formGroup">
  <legend class="form-builder-legend" *ngIf="!!fieldsetProps.title">
    {{ fieldsetProps.title | translate }}
  </legend>
  <div
    class="grid grid-cols-1 gap-2 md:grid-cols-2"
    [ngClass]="fieldsetProps?.className">
    <ng-container *ngFor="let field of fieldsetProps?.elements">
      <div class="input-group" [ngClass]="field?.className">
        <rd-form-builder-input
          [inputProps]="field.input"></rd-form-builder-input>
      </div>
    </ng-container>
  </div>
</fieldset>
